import { Platform } from '@angular/cdk/platform';
import { Component, OnInit } from '@angular/core';
import { ResourcesService } from 'app/services/resources.service';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-wipperoz-numbers',
  templateUrl: './wipperoz-numbers.component.html',
  styleUrls: ['./wipperoz-numbers.component.scss']
})
export class WipperozNumbersComponent implements OnInit {
  isLoading = false;
  countProviders = 0;
  countUsers = 0;
  countLocations = 0;
  countries = [];
  categories = [];
  uniqueProfessions = [];
  uniqueCoordinates = [];
  private unsubscribeAll: Subject<any>;

  constructor(private resourceService: ResourcesService, private platform: Platform) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.isLoading = true;

    this.resourceService.onUserStatisticsChanged
      .pipe(
        takeUntil(this.unsubscribeAll),
        filter((x: any) => {
          return x !== undefined;
        })
      )
      .subscribe((x) => {
        if (x !== null) {
          this.countUsers = this.resourceService.countUsers;
          this.countries = this.resourceService.countries;
          this.categories = this.resourceService.categoriesAll;
          this.uniqueProfessions = this.resourceService.uniqueProfessions;
          this.countLocations = this.resourceService.countLocations;
        }
      });

    if (this.resourceService.countUsers === 0) {
      this.resourceService.getUserStatistics();
    } else {
      this.countUsers = this.resourceService.countUsers;
      this.countries = this.resourceService.countries;
      this.categories = this.resourceService.categoriesAll;
      this.countLocations = this.resourceService.countLocations;
      this.uniqueProfessions = this.resourceService.uniqueProfessions;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
